import axios, { AxiosError } from 'axios';
import { toast } from '@/components/ui/use-toast'; // Assuming you're using toast for notifications

// Utility function for handling Axios errors
export const handleAxiosError = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError;

    // Handle response error
    if (axiosError.response) {
        const message = (axiosError.response?.data as { message?: string }).message || 'Something went wrong.';
        if (message.toLowerCase() === 'jwt expired') {
        return; // Don't show toast, silent refresh will handle it
      }
        toast({
        title: "Error",
        description: message,
        variant: "destructive",
      });
    }
    // Handle request error (e.g., no response from the server)
    else if (axiosError.request) {
      toast({
        title: "Error",
        description: "No response from the server. Please check your network connection.",
        variant: "destructive",
      });
    }
    // Handle other errors (e.g., Axios setup issues)
    else {
      toast({
        title: "Error",
        description: "An unexpected error occurred.",
        variant: "destructive",
      });
    }
  } else if (error instanceof Error) {
    // Handle non-Axios errors (e.g., network issues)
    toast({
      title: "Error",
      description: error.message || "An unexpected error occurred.",
      variant: "destructive",
    });
  } else {
    toast({
      title: "Error",
      description: "An unexpected error occurred.",
      variant: "destructive",
    });
  }
};
